import { render, staticRenderFns } from "./MyPlan.vue?vue&type=template&id=3ebc64b0&scoped=true"
import script from "./MyPlan.vue?vue&type=script&lang=js"
export * from "./MyPlan.vue?vue&type=script&lang=js"
import style0 from "./MyPlan.vue?vue&type=style&index=0&id=3ebc64b0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ebc64b0",
  null
  
)

export default component.exports